import { UseCase } from '@core/referential/use-case.enum'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'

import PendingComponent from '@/components/pending-component'
import { Permission } from '@/lib/permissions'
import { isUseCase } from '@/lib/utils'
import { reportConfigurationsQuery } from '@/queries/report-configuration.query'
import { reportsQuery } from '@/queries/report.query'

export const SearchSchema = z.object({
  tab: z.union([z.literal('reports'), z.literal('report-configurations')]).default('reports'),
})

export type Search = z.infer<typeof SearchSchema>

export const Route = createFileRoute('/_dashboard/site/$id/reports/')({
  validateSearch: SearchSchema,
  beforeLoad({ search, context }) {
    if (search.tab === 'report-configurations' && !context.user?.hasPermission(Permission.REPORT_CONFIGURATION)) {
      throw redirect({
        to: '/403',
      })
    }

    if (isUseCase(UseCase.ENERGY)) {
      throw redirect({
        to: '/403',
        search: { reason: 'wrongUseCase' },
      })
    }
  },
  loaderDeps({ search }) {
    return search
  },
  loader({ params, context: { queryClient }, deps: { tab } }) {
    if (tab === 'reports') {
      void queryClient.ensureQueryData(reportsQuery(params.id))
    }

    if (tab === 'report-configurations') {
      void queryClient.ensureQueryData(reportConfigurationsQuery(params.id))
    }
  },
  pendingComponent: PendingComponent,
})
